/**
 * SPDX-FileCopyrightText: (c) 2024 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

import React from 'react';

export default React.createContext({
	availableLanguages: {},
	defaultLocale: 'en_US',
	learnMessages: {},
	locale: 'en_US',
	namespace: '',
	redirectURL: '',
});
